import createAxiosInstance from './axiosFactory';
import createRefreshTokenInterceptor from './refreshTokenInterceptor';

const axiosInstance = createAxiosInstance();

axiosInstance.interceptors.response.use(...createRefreshTokenInterceptor());

export default axiosInstance;
